import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import Select from 'react-select';
import ApiCaller from '../../../../api/ApiCaller';
import ResponseParametersForm from '../components/ResponseParametersForm';

const SendEmailAction = ({ 
    formData, 
    setFormData, 
    allTableList, 
    selectedRequest, 
    allPreviousSteps, 
    currentStepId 
}) => {
    const [requestParameters, setRequestParameters] = useState([]);
    const [allRequestParameters, setAllRequestParameters] = useState([]);
    const [requestParamSource, setRequestParamSource] = useState(formData?.requestParamSource || ['custom_request']);
    const [responseParameters, setResponseParameters] = useState(formData?.responseParameters || []);

    // Effects
    useEffect(() => {
        requestParamSource.forEach(source => {
            if (source === 'custom_request') {
                fetchRequestParameters(selectedRequest);
            } else {
                loadStepParameters(source);
            }
        });
    }, [requestParamSource, selectedRequest, allPreviousSteps]);

    // Initialize state from formData when editing
    useEffect(() => {
        if (formData?.requestParamSource) {
            setRequestParamSource(formData.requestParamSource);
        }
    }, [formData?.requestParamSource]);

    useEffect(() => {
        if (formData?.responseParameters) {
            setResponseParameters(formData.responseParameters);
        }
    }, [formData?.responseParameters]);

    // Helper Functions
    const getParameterSourcePrefix = (parameter) => {
        if (!parameter) return '';
        if (parameter.label?.includes('Custom Request')) return 'custom_request';
        const stepMatch = parameter.label?.match(/Step (\d+)/);
        if (stepMatch) return `step_${stepMatch[1]}`;
        return 'custom_request';
    };

    const fetchRequestParameters = (requestId) => {
        if (!requestId) return;
        
        const url = `api/generic-request/${requestId}/parameters`;
        ApiCaller.callGetApi(url, {}, (response) => {
            const params = response?.data || [];
            const formattedParams = params.map(param => ({
                value: param.name,
                label: `Custom Request - ${param.name}`,
                type: param.type
            }));
            setAllRequestParameters(prev => [...prev, ...formattedParams]);
            setRequestParameters(prev => [...prev, ...formattedParams]);
        }, (error) => {
            console.error('Error fetching request parameters:', error);
        });
    };

    const loadStepParameters = (stepSource) => {
        const stepMatch = stepSource.match(/step_(\d+)/);
        if (!stepMatch) return;

        const stepId = parseInt(stepMatch[1]);
        const step = allPreviousSteps.find(s => s.id === stepId);
        if (!step || !step.actions || step.actions.length === 0) return;

        const action = step.actions[0];
        if (action.config?.responseParameters) {
            const stepParams = action.config.responseParameters.map(param => ({
                value: param.name,
                label: `Step ${stepId} - ${param.name}`,
                type: param.type
            }));
            setAllRequestParameters(prev => [...prev, ...stepParams]);
            setRequestParameters(prev => [...prev, ...stepParams]);
        }
    };

    // Event Handlers
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleRequestParamSourceChange = (selectedOptions) => {
        const values = selectedOptions ? selectedOptions?.map(option => option?.value) : ['custom_request'];
        setRequestParamSource(values);
        setFormData((prev) => ({
            ...prev,
            requestParamSource: values,
        }));
    };

    const renderRequestParameterSource = () => {
        const options = [
            { value: 'custom_request', label: 'Custom Request' },
            ...allPreviousSteps.map(step => ({
                value: `step_${step.id}`,
                label: `Step ${step.id}`
            }))
        ];

        return (
            <Form.Group className="mt-3">
                <Form.Label>Parameter Source</Form.Label>
                <Select
                    isMulti
                    options={options}
                    value={options.filter(option => requestParamSource.includes(option.value))}
                    onChange={handleRequestParamSourceChange}
                    placeholder="Select parameter sources"
                    className="react-select-container"
                />
            </Form.Group>
        );
    };

    return (
        <>
            <Form.Group>
                <Form.Label>Email Template</Form.Label>
                <Form.Control 
                    as="textarea" 
                    name="emailTemplate" 
                    value={formData?.emailTemplate || ''} 
                    onChange={handleChange}
                    placeholder="Enter email template (use {{parameter}} for dynamic values)"
                    rows={4}
                />
            </Form.Group>

            <Form.Group className="mt-3">
                <Form.Label>To Email</Form.Label>
                <Form.Control 
                    type="email" 
                    name="toEmail" 
                    value={formData?.toEmail || ''} 
                    onChange={handleChange}
                    placeholder="Enter recipient email address"
                />
            </Form.Group>

            <Form.Group className="mt-3">
                <Form.Label>Subject</Form.Label>
                <Form.Control 
                    type="text" 
                    name="subject" 
                    value={formData?.subject || ''} 
                    onChange={handleChange}
                    placeholder="Enter email subject"
                />
            </Form.Group>

            {renderRequestParameterSource()}

            <ResponseParametersForm
                responseParameters={responseParameters}
                setResponseParameters={setResponseParameters}
                formData={formData}
                setFormData={setFormData}
            />
        </>
    );
};

export default SendEmailAction; 